import { render } from "./MarketingForm.vue?vue&type=template&id=32cf894c&scoped=true"
import script from "./MarketingForm.vue?vue&type=script&lang=js"
export * from "./MarketingForm.vue?vue&type=script&lang=js"

import "./MarketingForm.vue?vue&type=style&index=0&id=32cf894c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cf894c"]])

export default __exports__